import React from 'react';
import { object, array, bool } from 'prop-types';
import FeaturedSellersCarousel from './FeaturedSellersCarousel';
import CollectionsCarousel from './CollectionsCarousel';
import FeaturedProductsCarousel from './FeaturedProductsCarousel';
import { NamedLink } from '../../components';

const ArtSection = ({
  // Remove featuredSellersSection CMS prop - component now gets data directly from Redux
  collectionsSection,
  featuredListings,
  featuredListingsInProgress,
  featuredListingsError,
  artCategoryArtists,
  artCategoryArtistsInProgress,
  artCategoryArtistsError,
  currentUser
}) => {
  return (
    <section id="art" className="pb-12 pt-4">
      <div className="max-w-7xl mx-auto rounded-3xl md:p-8 md:bg-[var(--colorArt)]/5">

        {/* Section Header */}
        <div className="flex items-center gap-3 mb-12 border-b border-black opacity-100 mx-4">
         
          <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-black pb-3 font-['Be_Vietnam_Pro']">
            Shop Wall Art
          </h2>
          <NamedLink
            name="SearchPageWithListingType"
            params={{ listingType: 'art' }}
            className="ml-auto px-6 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors"
          >
            Browse All →
          </NamedLink>
        </div>

        {/* Art category links */}
        <div className="flex flex-wrap gap-2 px-4 mb-2">
          {[
            { href: '/s/art/the_classics', label: 'Jerusalem wall art' },
            { href: '/s/art/gedolim', label: 'Gedolim portraits' },
            { href: '/s/art/jewish_icons', label: 'Jewish Life & Tradition Art' },
            { href: '/s/art/around_the_home', label: 'Jewish Art for the Home' },
            { href: '/artist/custom_co_studio', label: 'Commission a piece' },
          ].map(({ href, label }) => (
            <a
              key={href}
              href={href}
              className="px-3 py-1 text-xs font-medium text-stone-600 bg-white/70 rounded-full border border-stone-200 hover:border-[var(--colorArt)] hover:text-[var(--colorArt)] transition-all duration-200"
            >
              {label}
            </a>
          ))}
        </div>

        {/* Content */}
        <div className="space-y-12">
          {/* Featured Sellers Carousel - now gets data from props */}
          <div className="py-4">
            <div className="flex flex-col ml-8 mb-4">
              <h2 className="md:text-2xl text-xl font-sbold text-black font-['Be_Vietnam_Pro'] mt-4 mb-0">
                Artist Spotlight
              </h2>
              <NamedLink
                name="ArtistDirectoryPage"
                params={{ listingType: 'art' }}
                className="mt-1"
              >
                View All Artists →
              </NamedLink>
            </div>
            <FeaturedSellersCarousel
              sectionId="art-sellers-carousel"
              numColumns={3}
              artistCategory="art"
              artists={artCategoryArtists}
              inProgress={artCategoryArtistsInProgress}
              error={artCategoryArtistsError}
            />
          </div>

          <div>
            <h3 className="text-lg sm:text-xl font-semibold text-black font-['Be_Vietnam_Pro'] ml-8 mx-4">
              Featured Art
            </h3>
            <FeaturedProductsCarousel
              featuredListings={featuredListings}
              inProgress={featuredListingsInProgress}
              error={featuredListingsError}
              currentUser={currentUser}
              id="art-featured-products-carousel"
            />
          </div>

        </div>

      </div>
    </section>
  );
};

ArtSection.propTypes = {
  // Remove featuredSellersSection from propTypes
  collectionsSection: object,
  featuredListings: array,
  featuredListingsInProgress: bool,
  featuredListingsError: object,
  artCategoryArtists: array,
  artCategoryArtistsInProgress: bool,
  artCategoryArtistsError: object,
  currentUser: object,
};

export default ArtSection; 